import { Component, Inject, Input } from '@angular/core';
import { CaptionService } from '../../../../utils/shared-services/caption.service';



@Component({
    selector: 'hoWid000',
    templateUrl: 'src/app/features/head-office-portal/widgets/templates/wid-000.html',
    standalone: false
})
export class HoWid000 {
  public captions: any;
  @Input() isTimedOut: boolean = false;

  constructor(@Inject(CaptionService) private captionService) {
    
    this.captions = this.captionService.captions;

   }

  ngOnInit() { }
}